import { render } from "./EnbNews.vue?vue&type=template&id=e584b9f4&scoped=true"
import script from "./EnbNews.vue?vue&type=script&lang=js"
export * from "./EnbNews.vue?vue&type=script&lang=js"

import "./EnbNews.vue?vue&type=style&index=0&id=e584b9f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e584b9f4"]])

export default __exports__